import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VerifyPage.css';

const API_PREFIX = 'https://rhinoapi.thevoicebusiness.com.au';

function VerifyPage() {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const uuid = localStorage.getItem('uuid');
    try {
      const res = await fetch(`${API_PREFIX}/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uuid, otp }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        localStorage.setItem('token', data.token);
        navigate('/dashboard');
      } else {
        setError(data.message || 'Invalid OTP');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container min-vh-100 d-flex align-items-center justify-content-center bg-glass-bg">
      <div className="glass-card p-4 shadow-lg w-100" style={{maxWidth: 400}}>
        <h2 className="mb-4 text-center fw-bold">Verify OTP</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control form-control-lg text-center fs-3 tracking-wide"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              required
              pattern="\d{6}"
              maxLength={6}
            />
          </div>
          <button type="submit" className="btn btn-success w-100 btn-lg mb-2" disabled={loading || otp.length !== 6}>
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
          {error && <div className="alert alert-danger mt-2 py-2 text-center">{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default VerifyPage; 